import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";

function conflictingModuleNames(modules) {
  var moduleNames = modules.map(function (mod) {
    return mod.name;
  });
  var nameCounts = moduleNames.reduce(function (names, moduleName) {
    return Object.assign(names, _defineProperty({}, moduleName, (names[moduleName] || 0) + 1));
  }, {});
  var duplicatedNames = moduleNames.filter(function (moduleName) {
    return nameCounts[moduleName] > 1;
  });

  if (duplicatedNames.length > 0) {
    throw new Error("Duplicate module names: [ ".concat(duplicatedNames.join(', '), " ]"));
  }

  return false;
}

function missingModuleNames(modules) {
  var moduleMissingName = modules.find(function (mod) {
    return !mod.name;
  });

  if (moduleMissingName) {
    throw new Error('Module missing name!');
  }

  return false;
}

export function assertModuleSanity(modules) {
  return !(missingModuleNames(modules) || conflictingModuleNames(modules));
}